import $ from "jquery";
import lightbox from "lightbox2";

$(document).ready(function () {
  $('[rel="popover"]').popover({ trigger: "hover focus" });
});

lightbox.option({
  showImageNumberLabel: false,
});
